import { STANDARD_QUEUE_TABS, TicketsView, type TicketsViewConfig } from './TicketsView';

const config: TicketsViewConfig = {
  title: 'Queues',
  // v2: switched from "status: New" to "all unassigned, any status" (bumped to drop
  // the stale persisted status:[1] filter from users who saw the old default).
  storageKeyFilters: 'cosmos:filters:dispatch:v2',
  storageKeySort: 'cosmos:sort:dispatch:v1',
  defaultFilters: {
    assignedTo: 'any',
    // No status filter — dispatch shows unassigned tickets in any (still-open) status. The
    // Status multi-select still lets you narrow (e.g. to New) without ever revealing assigned
    // tickets, because `unassigned` is always applied regardless of status.
    status: [],
    // Hide "Complete" (5) and "Complete-Pending Customer" (21) — a dispatch queue is for
    // work that still needs assigning, so finished tickets are noise. (Mirrors My Tickets.)
    excludeStatus: [5, 21],
    queueID: [],
    priority: [],
    search: '',
    unassigned: true,
  },
  queueTabs: STANDARD_QUEUE_TABS,
  showAssignee: true,
  // This view is defined as unassigned-only, so the "My tickets" toggle would produce a
  // contradictory (always-empty) query — hide it.
  unassignedOnly: true,
};

export default function QueuesPage() {
  return <TicketsView config={config} />;
}
